module.exports = "/_next/static/images/danamon-c763f68c00083a2b563ffbce659020d4.png";